import React, { useState } from 'react'

const DatePicker2 = ({
  placeholderValue,
  labelValue,
  value,
  name,
  onChange,
  required,
  title,
  minDate,
}) => {
  return (
    <div className="flex gap-1  w-full max-w-96 flex-col text-start">
      <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
        {labelValue}
      </label>
      <div>
        <input
          type="date"
          className=" border-b border-gray-300 text-gray-900 text-xs md:text-base focus:border-b focus:border-blue-500 block w-full pb-1 pt-1 outline-none"
          placeholder="Select date"
          value={value || ''}
          name={name}
          onChange={onChange}
          title={title}
          required={required}
          min={minDate && minDate}
        />
      </div>
    </div>
  )
}

export default DatePicker2
